import React from 'react';

type Props = {};

const MasterPageIndex = (props: Props) => {
  return (
    <div>MasterPageLayout</div>
  );
};

export default MasterPageIndex;